module.exports = __webpack_public_path__ + "mainassets/img/search-plus.294c85be.svg";